module.exports = __webpack_public_path__ + "static/media/banner1.d00791fc.png";